export default __webpack_public_path__ + "static/media/usdt.6dc09781.svg";